import React, { Fragment } from 'react'

import { styled } from '@material-ui/core/styles'

import ArrowForwardIcon from '@material-ui/icons/ArrowForward'

import {
  Divider,
  IconButton,
  List,
  ListItem,
  ListItemIcon,
  ListItemSecondaryAction,
  ListItemText,
  Paper,
  Typography
} from '@material-ui/core'


const Root = styled('div')({
  margin: 10,
  marginTop: 20,
})
const Card = styled('div')({
  '&:not(:last-child)': {
    marginBottom: 20,
  },
})
const ListHeader = styled(Typography)({
  padding: '0 10px',
  marginBottom: 5,
  color: 'gray',
})
const ListTitle = styled(ListItemText)({
  whiteSpace: 'nowrap',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
})

function eachCardContent({ label, action = {}, actions = [], onClick, Icon }, index, content) {
  // Support both single action and multiple actions
  const actionList = actions.length > 0 ? actions : (action.onClick ? [action] : [])
  
  return (
    <Fragment key={index}>
      <ListItem button onClick={onClick}>
        {Icon && (
          <ListItemIcon>
            <Icon />
          </ListItemIcon>
        )}

        <ListTitle primary={label} />

        <ListItemSecondaryAction>
          {actionList.length > 0 ? (
            actionList.map((act, idx) => (
              <IconButton 
                key={idx}
                disabled={!act.onClick} 
                onClick={act.onClick} 
                edge={idx === actionList.length - 1 ? "end" : false}
              >
                {act.Icon || <ArrowForwardIcon />}
              </IconButton>
            ))
          ) : (
            <IconButton disabled edge="end">
              <ArrowForwardIcon />
            </IconButton>
          )}
        </ListItemSecondaryAction>
      </ListItem>
      
      {content.length - 1 > index && (
        <Divider component="li" />
      )}
    </Fragment>
  )
}

function eachCard({ title, content }, index) {
  return (
    <Card key={index}>
      {title && (
        <ListHeader>
          {title}
        </ListHeader>
      )}

      <Paper square>
        <List>
          {content
            .filter(({hidden}) => !hidden)
            .map(eachCardContent)}
        </List>
      </Paper>
    </Card>
  )
}

export default ({ menuItems }) => {
  return (
    <Root>
      {menuItems.map(eachCard)}
    </Root>
  )
}
